var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreatecarpetid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7A99"
    },
    d: "M89.043,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696C72.348,7.473,79.826,0,89.043,0 s16.696,7.473,16.696,16.696v33.391C105.739,59.31,98.261,66.783,89.043,66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7A99"
    },
    d: "M155.826,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696C139.13,7.473,146.609,0,155.826,0 s16.696,7.473,16.696,16.696v33.391C172.522,59.31,165.043,66.783,155.826,66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7A99"
    },
    d: "M222.609,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696C205.913,7.473,213.392,0,222.609,0 s16.696,7.473,16.696,16.696v33.391C239.304,59.31,231.826,66.783,222.609,66.783z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A6680"
    },
    d: "M289.391,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696C272.696,7.473,280.174,0,289.391,0 c9.217,0,16.696,7.473,16.696,16.696v33.391C306.087,59.31,298.608,66.783,289.391,66.783z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#5A6680"
    },
    d: "M422.957,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696 C406.261,7.473,413.739,0,422.957,0c9.217,0,16.696,7.473,16.696,16.696v33.391C439.652,59.31,432.174,66.783,422.957,66.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7A99"
    },
    d: "M89.043,512c-9.217,0-16.696-7.473-16.696-16.696v-33.391c0-9.223,7.479-16.696,16.696-16.696 s16.696,7.473,16.696,16.696v33.391C105.739,504.527,98.261,512,89.043,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7A99"
    },
    d: "M155.826,512c-9.217,0-16.696-7.473-16.696-16.696v-33.391c0-9.223,7.479-16.696,16.696-16.696 s16.696,7.473,16.696,16.696v33.391C172.522,504.527,165.043,512,155.826,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7A99"
    },
    d: "M222.609,512c-9.217,0-16.696-7.473-16.696-16.696v-33.391c0-9.223,7.479-16.696,16.696-16.696 s16.696,7.473,16.696,16.696v33.391C239.304,504.527,231.826,512,222.609,512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A6680"
    },
    d: "M289.391,512c-9.217,0-16.696-7.473-16.696-16.696v-33.391c0-9.223,7.479-16.696,16.696-16.696 c9.217,0,16.696,7.473,16.696,16.696v33.391C306.087,504.527,298.608,512,289.391,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A6680"
    },
    d: "M356.174,512c-9.217,0-16.696-7.473-16.696-16.696v-33.391c0-9.223,7.479-16.696,16.696-16.696 c9.217,0,16.696,7.473,16.696,16.696v33.391C372.87,504.527,365.391,512,356.174,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A6680"
    },
    d: "M356.174,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696C339.478,7.473,346.957,0,356.174,0 c9.217,0,16.696,7.473,16.696,16.696v33.391C372.87,59.31,365.391,66.783,356.174,66.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#5A6680"
    },
    d: "M422.957,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696 C406.261,7.473,413.739,0,422.957,0c9.217,0,16.696,7.473,16.696,16.696v33.391C439.652,59.31,432.174,66.783,422.957,66.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_2_",
    style: {
      fill: "#5A6680"
    },
    d: "M422.957,66.783c-9.217,0-16.696-7.473-16.696-16.696V16.696 C406.261,7.473,413.739,0,422.957,0c9.217,0,16.696,7.473,16.696,16.696v33.391C439.652,59.31,432.174,66.783,422.957,66.783z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A6680"
    },
    d: "M422.957,512c-9.217,0-16.696-7.473-16.696-16.696v-33.391c0-9.223,7.479-16.696,16.696-16.696 c9.217,0,16.696,7.473,16.696,16.696v33.391C439.652,504.527,432.174,512,422.957,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AACE6"
    },
    d: "M422.957,478.609H89.043c-9.217,0-16.696-7.473-16.696-16.696V50.087 c0-9.223,7.479-16.696,16.696-16.696h333.913c9.217,0,16.696,7.473,16.696,16.696v411.826 C439.652,471.136,432.174,478.609,422.957,478.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B9FD9"
    },
    d: "M422.957,33.391H256v445.217h166.957c9.217,0,16.696-7.473,16.696-16.696V50.087 C439.652,40.864,432.174,33.391,422.957,33.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC033"
    },
    d: "M306.087,411.826H205.913c-9.217,0-16.696-7.473-16.696-16.696c0-18.413-14.978-33.391-33.391-33.391 c-9.217,0-16.696-7.473-16.696-16.696V166.957c0-9.223,7.479-16.696,16.696-16.696c18.413,0,33.391-14.978,33.391-33.391 c0-9.223,7.479-16.696,16.696-16.696h100.174c9.217,0,16.696,7.473,16.696,16.696c0,18.413,14.978,33.391,33.391,33.391 c9.217,0,16.696,7.473,16.696,16.696v178.087c0,9.223-7.479,16.696-16.696,16.696c-18.413,0-33.391,14.978-33.391,33.391 C322.783,404.353,315.304,411.826,306.087,411.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A926"
    },
    d: "M356.174,150.261c-18.413,0-33.391-14.978-33.391-33.391c0-9.223-7.479-16.696-16.696-16.696H256 v311.652h50.087c9.217,0,16.696-7.473,16.696-16.696c0-18.413,14.978-33.391,33.391-33.391c9.217,0,16.696-7.473,16.696-16.696 V166.957C372.87,157.734,365.391,150.261,356.174,150.261z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatecarpetid);
export default __webpack_public_path__ + "static/media/Createcarpetid.8480f63b1d1933931c5add70220cedcf.svg";
export { ForwardRef as ReactComponent };